/*
 * @Description:
 * @Author: lz
 * @Date: 2021-06-16 17:57:30
 * @LastEditTime: 2021-06-26 16:48:18
 * @LastEditors: lz
 */
import request from '@/utils/request'

//获取项目类别筛选列表
export function getProjectCat(params) {
  return request({
    url: '/policy/listItemCategory',
    method: 'get',
    params,
  })
}

//获取产业类别列表
export function getIndustryCat(params) {
  return request({
    url: '/policy/listIndustryCategory',
    method: 'get',
    params,
  })
}

//获取产业类别列表 新
export function getListBusinessCategory(params) {
  return request({
    url: '/policy/listBusinessCategory',
    method: 'get',
    params,
  })
}

//获取全部城市(地级市)列表
export function getCity(params) {
  return request({
    url: '/area/listTreeCity',
    method: 'get',
    params,
  })
}

//获取受理部门及政策区域筛选列表
export function getAcceptDept(data) {
  return request({
    url: '/area/listPolicyAreas',
    method: 'post',
    data,
  })
}

//政策分页查询  (外部)
export function getPolicyList(data) {
  return request({
    url: '/policy/outer/list',
    method: 'post',
    data,
  })
}

//政策分页查询  (本站)
export function getList(data) {
  return request({
    url: '/policy/list',
    method: 'post',
    data,
  })
}

// 政策列表
export function youcewangPolicyListApi(data) {
  return request({
    url: '/youcewang/policy/list',
    method: 'post',
    data,
  })
}

// 政策列表筛选
export function youcewangPolicyOptionsApi(data) {
  return request({
    url: '/youcewang/policy/options',
    method: 'post',
    data,
  })
}
// 政策列表跳转详情
export function youcewangPolicyInfoApi(data) {
  return request({
    url: '/youcewang/policy/info',
    method: 'post',
    data,
  })
}